<template>
  <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search fcl-search-bar">
    <div v-show="showSimple" class="cargo-advance-search-header">
      <div class="cargo-advance-search-toggle-trigger">
        <i
          v-show="showAdv"
          class="el-icon-arrow-left"
          :style="{transform: !isShowingMoreSearchCondition?'rotate(-90deg)':'rotate(90deg)'}"
          @click="upOrDownSearchCondition"
        />
      </div>
      <div v-show="showSimple && !isShowingMoreSearchCondition" class="cargo-advance-search-quick">
        <!--清空时不需要弹出提示，只有输入框为空，点击查询时才需要弹出提示-->
        <!--@clear="simSearch"-->
        <el-input
          v-if="showPriceNo"
          ref="keyword"
          v-model="filter.priceNo"
          no="showPriceNo"
          style="width:200px;"
          :placeholder="simQueryPlaceholder"
          :spellcheck="false"
          @blur="keyWordBlur"
          @keyup.enter.native.prevent="toQuery"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && showPriceNo"
          no="currency"
          style="width: 115px;display: inline-block;"
          filterable
          :disabled="disabled"
          :clearable="false"
          :select-type="selectTypeNames.basic_data_Currency"
          :default-value="filter.currency"
          @parentCallBack="changeCurrency"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && !showPriceNo"
          ref="simPol"
          no="simPol"
          filterable
          :placeholder="$t('Pricing.POLPrompt')"
          :select-type="selectTypeNames.basic_data_Airport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          :default-value="filter.simPol"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.simPol=p.value}"
        />
        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && !showPriceNo"
          ref="simPod"
          no="simPod"
          filterable
          :placeholder="$t('Pricing.PODPrompt')"
          :select-type="selectTypeNames.basic_data_Airport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          :default-value="filter.simPod"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.simPod=p.value}"
        />
        <el-select
          v-if="!isShowingMoreSearchCondition && showLevel"
          v-model="filter.level"
          no="levelTiers"
          style="width:90px;display: inline-block;margin-left: 10px;"
          @change="onLevelChanged"
        >
          <el-option
            v-for="(item,index) in tiers"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>

        <!--        这里请求接口会报错，屏蔽掉-->
        <!--        <cargo-advance-select-->
        <!--          v-if="!isShowingMoreSearchCondition && !showPriceNo"-->
        <!--          ref="flightNumber"-->
        <!--          :remote="true"-->
        <!--          :cache="false"-->
        <!--          no="flightNumber"-->
        <!--          filterable-->
        <!--          :url="URL.booking.airExport.queryFlights"-->
        <!--          :placeholder="$t('SeaExport.FlightNo')"-->
        <!--          tag-name="flightNo"-->
        <!--          tag-value="flightNo"-->
        <!--          :default-value="filter.flightNumber"-->
        <!--          style="width:190px;display: inline-block;margin-left: 10px;"-->
        <!--          @parentCallBack="p=>{filter.flightNumber=p.value}"-->
        <!--        />-->

        <cargo-advance-select
          v-if="!isShowingMoreSearchCondition && !showPriceNo"
          ref="aircraft"
          no="aircraft"
          filterable
          :placeholder="$t('Pricing.Aircraft')"
          :select-type="selectTypeNames.basic_data_AirplaneModel"
          :filter-tag-names="['model']"
          tag-name="model"
          tag-value="model"
          :default-value="filter.aircraft"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.aircraft=p.value}"
        />
      </div>
      <div ref="searchOperations" class="cargo-advance-search-operations">
        <el-button no="toQuery" style="margin-left: 10px" type="primary" :disabled="disabled" @click="toQuery">
          {{ $t('CargoMsg.Cargo_Query') }}
        </el-button>
        <el-button no="resetSearch" type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
        <slot name="operations">
          <!--页面操作按钮-->
        </slot>
      </div>
    </div>
    <slot name="searchAreaHeader">
      <!--搜索条件区域-头-->
    </slot>
    <div
      v-if="showAdv"
      v-show="isShowingMoreSearchCondition"
      class="section cargo-advance-search-more"
    >
      <div class="cargo-advance-search-more-operations" />
      <el-form ref="hbDetail" label-width="80px" label-position="left" :inline="true">
        <el-radio-group v-model="rdoGroupOrg" no="rdoGroupOrg">
          <el-radio no="pol" label="pol">{{ $t('Pricing.POL') }}</el-radio>
          <el-radio no="pols" label="pols">{{ $t('Pricing.POLs') }}</el-radio>
          <el-radio no="col" label="col">{{ $t('Pricing.COL') }}</el-radio>
          <el-radio no="rol" label="rol">{{ $t('Pricing.ROL') }}</el-radio>
          <el-radio no="polCityCode" label="polCityCode">{{ $t('Pricing.POLCity') }}</el-radio>
        </el-radio-group>
        <cargo-pop-select-input
          v-if="rdoGroupOrg === 'pols'"
          v-model="filter.pols"
          no="pols"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :column-defs="popSelectInputCols"
          :select-type="selectTypeNames.basic_data_Airport"
          :use-type="3"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'pol'"
          no="pol"
          filterable
          :placeholder="$t('Pricing.POLPrompt')"
          :select-type="selectTypeNames.basic_data_Airport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          callback-method-type="obj"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :default-value="filter.pol"
          @parentCallBack="polChange"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'col'"
          no="col"
          filterable
          :placeholder="$t('Pricing.COLPrompt')"
          :select-type="selectTypeNames.basic_data_Country"
          :default-value="filter.col"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.col=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'rol'"
          no="rol"
          filterable
          :select-type="selectTypeNames.basic_data_Region"
          :default-value="filter.rol"
          style="width:190px;display: inline-block;;margin-left: 10px;"
          @parentCallBack="p=>{filter.rol=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupOrg === 'polCityCode'"
          no="polCityCode"
          :static-options="cityAirport"
          tag-name="name"
          tag-value="code"
          :placeholder="$t('Pricing.POLCityPrompt')"
          clearable
          filterable
          :filter-tag-names="['name', 'code']"
          style="width:190px;display: inline-block;;margin-left: 10px;"
          :default-value="filter.polCityCode"
          @parentCallBack="p=>{filter.polCityCode=p.value}"
        />
        <el-form-item :label="$t('Pricing.Carrier_Air')" style="margin-left: 10px;">
          <cargo-advance-select
            no="carrier"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{airCmp:true}"
            :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
            :show-custom-label-in-option="true"
            :default-value="filter.carrier"
            style="width:242px;"
            @parentCallBack="p=>{filter.carrier=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="isManageModule || isShowCreatedBy" :label="$t('Pricing.CreatedBy')" style="margin-left: 10px;">
          <cargo-advance-select
            no="createdBy"
            filterable
            :select-type="selectTypeNames.basic_data_User"
            :default-value="filter.createdBy"
            :callback-params="{key:'userId'}"
            style="width:190px;display: inline-block;margin-left: 10px;"
            @parentCallBack="p=>{filter.createdBy=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="showCurrency" :label="$t('Pricing.Currency')" style="margin-left: 10px;">
          <cargo-advance-select
            no="currency"
            style="width: 115px;"
            filterable
            :disabled="disabled"
            :clearable="false"
            :default-value="filter.currency"
            :select-type="selectTypeNames.basic_data_Currency"
            @parentCallBack="changeCurrency"
          />
        </el-form-item>
        <el-form-item :label="$t('Pricing.CreatedDate')">
          <el-date-picker
            v-model="filter.createDateFrom"
            no="createDateFrom"
            type="date"
            style="width:130px;margin-left:10px"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() >
                  new Date(filter.createDateTo + ' 23:59:59').getTime()
                )
              }
            }"
            value-format="yyyy-MM-dd"
          />
          <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
          <el-date-picker
            v-model="filter.createDateTo"
            no="createDateTo"
            :picker-options="{
              disabledDate: time => {
                return (
                  time.getTime() <
                  new Date(filter.createDateFrom + ' 00:00:00').getTime()
                )
              }
            }"
            type="date"
            style="width:130px;margin-left:10px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </el-form>
      <el-form ref="hbDetail2" label-width="80px" label-position="left" :inline="true">
        <el-radio-group v-model="rdoGroupDes" no="rdoGroupDes">
          <el-radio no="pod" label="pod">{{ $t('Pricing.POD') }}</el-radio>
          <el-radio no="pods" label="pods">{{ $t('Pricing.PODs') }}</el-radio>
          <el-radio no="cod" label="cod">{{ $t('Pricing.COD') }}</el-radio>
          <el-radio no="rod" label="rod">{{ $t('Pricing.ROD') }}</el-radio>
          <el-radio no="podCityCode" label="podCityCode">{{ $t('Pricing.PODCity') }}</el-radio>
        </el-radio-group>
        <cargo-advance-select
          v-if="rdoGroupDes === 'pod'"
          no="pod"
          filterable
          :placeholder="$t('Pricing.PODPrompt2')"
          :select-type="selectTypeNames.basic_data_Airport"
          :custom-label="(item)=>`[${item.code}]${item.englishName}`"
          :filter-tag-names="['code','englishName']"
          :show-custom-label-in-option="true"
          :default-value="filter.pod"
          callback-method-type="obj"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="podChange"
        />
        <cargo-pop-select-input
          v-if="rdoGroupDes === 'pods'"
          v-model="filter.pods"
          no="pods"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :column-defs="popSelectInputCols"
          :select-type="selectTypeNames.basic_data_Airport"
          :use-type="3"
        />
        <cargo-advance-select
          v-if="rdoGroupDes === 'cod'"
          no="cod"
          filterable
          :placeholder="$t('Pricing.CODAirPrompt')"
          :select-type="selectTypeNames.basic_data_Country"
          :default-value="filter.cod"
          style="width:190px;display: inline-block;margin-left: 10px;"
          @parentCallBack="p=>{filter.cod=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupDes === 'rod'"
          no="rod"
          filterable
          :select-type="selectTypeNames.basic_data_Region"
          style="width:190px;display: inline-block;margin-left: 10px;"
          :default-value="filter.rod"
          @parentCallBack="p=>{filter.rod=p.value}"
        />
        <cargo-advance-select
          v-if="rdoGroupDes === 'podCityCode'"
          no="podCityCode"
          :static-options="cityAirport"
          tag-name="name"
          tag-value="code"
          :placeholder="$t('Pricing.PODCityPrompt')"
          clearable
          filterable
          :filter-tag-names="['name', 'code']"
          style="width:190px;display: inline-block;;margin-left: 10px;"
          :default-value="filter.podCityCode"
          @parentCallBack="p=>{filter.podCityCode=p.value}"
        />
        <el-form-item :label="$t('Pricing.BeginDate')" style="margin-left: 10px;">
          <div style="display: flex">
            <el-date-picker
              v-model="filter.beginDate"
              no="beginDate"
              type="date"
              style="width:110px;"
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() >
                    new Date(filter.endDate + ' 23:59:59').getTime()
                  )
                }
              }"
              value-format="yyyy-MM-dd"
            />
            <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
            <el-date-picker
              v-model="filter.endDate"
              no="endDate"
              type="date"
              style="width:110px;"
              :picker-options="{
                disabledDate: time => {
                  return (
                    time.getTime() <
                    new Date(filter.beginDate + ' 00:00:00').getTime()
                  )
                }
              }"
              value-format="yyyy-MM-dd"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="showLevel" :label="$t('Pricing.Level')" style="margin-left: 10px;">
          <el-select
            v-model="filter.level"
            no="level"
            style="width:190px;display: inline-block;margin-left: 10px;"
            @change="onLevelChanged"
          >
            <el-option
              v-for="(item,index) in tiers"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="showAllIn" label="All In" style="margin-left: 10px;">
          <el-checkbox v-model="filter.allIn" no="allIn" />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import StrUtils from '@/utils/StrUtils'
import { PricingAirConfigUtil } from '@/class/cargo/model/utils/PricingAirConfigUtil'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import { PriceAirPrivilegeUtils } from '@/class/cargo/model/utils/PriceAirPrivilegeUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as commonUtil from '@/utils/commonUtil'
import { deepClone } from '@/utils'
import CargoPopSelectInput from '@/components/Cargo/Common/CargoPopSelectInput/index'

export default {
  name: 'AirSearchBar',
  components: {
    CargoPopSelectInput,
    searchItem, cargoAdvanceSelect, cargoOfficeSelect
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    disabled: { type: Boolean, default: false }, // 禁用
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    isShowCreatedBy: { type: Boolean, default: false },
    isManageModule: { type: Boolean, default: false },
    isQueryPrice: { type: Boolean, default: false },
    isShowContractNo: { type: Boolean, default: false },
    isShowSaleState: { type: Boolean, default: false },
    showCurrency: { type: Boolean, default: false },
    showPriceNo: { type: Boolean, default: false },
    showAllIn: { type: Boolean, default: false },
    showSchedule: { type: Boolean, default: true }, // 是否显示船期
    isQuery: { type: Boolean, default: false }, // 是否是查询界面
    isSurcharge: { type: Boolean, default: false },
    configId: { type: String, required: true },
    filter: { type: Object, default: () => {
      return {}
    }
    }
  },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      showLevel: false, // 是否显示运价等级
      tiers: [],
      pgsLMap: null,
      pgsDMap: null,
      colsMap: null, // 按国家存储起运港
      codsMap: null, // 按国家存储卸货港
      pols: null, //
      pods: null, //
      allAirPort: null,
      polPort: null,
      podPort: null,
      isAlertShowed: false,
      rdoGroupOrg: 'pol',
      rdoGroupDes: 'pod',
      rowData: [],
      txtRemarks: '',
      remarkChange: false,
      needAddon: false,
      cityAirport: ColumnUtils.getCityAirport(),
      simQueryPlaceholder: this.$t('Pricing.priceNoPrompt'), // 快捷检索 占位符
      isAdvancedQuery: false, // 是否为高级查询
      isShowingMoreSearchCondition: this.expandAdv,
      proxy: {},
      showDetail: false,
      keyWords: null,
      privilegeUtil: null,
      popSelectInputCols: [
        {
          colId: 'code',
          field: 'code',
          headerName: this.$t('Price.Code')
        }, {
          colId: 'chineseName',
          field: 'chineseName',
          headerName: this.$t('Price.ChineseName')
        }, {
          colId: 'englishName',
          field: 'englishName',
          headerName: this.$t('Price.EnglishName')
        }, {
          colId: 'countryCnName',
          field: 'countryCnName',
          headerName: this.$t('Price.Country')
        }, {
          colId: 'region',
          field: 'region',
          headerName: this.$t('Price.Region'),
          valueFormatter: (params) => {
            const { data } = params
            return this.$store.getters.language === 'zh' ? data.regionCnName : data.regionEnName
          }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    localConfigId() {
      return this.configId + this.$store.getters.userId
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      // this.init()
      // this.toQuery()
    },
    isShowingMoreSearchCondition(newVal) {
      this.$emit('advToggle', newVal)
    },
    'filter.allIn': function() {
      this.$emit('onGridRefresh')
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const airConfig = await PricingAirConfigUtil.getInstance()
      this.privilegeUtil = await PriceAirPrivilegeUtils.getInstance()
      this.isAdminOrHQ = this.privilegeUtil.isAdminOrHQ
      this.allAirPort = await this.privilegeUtil.getAllAirPort()
      this.tenantUtil = await TenantUtil.getInstance()
      if (airConfig._needMarkup) {
        this.showLevel = this.privilegeUtil.isShowTier || this.privilegeUtil.isApprove
        this.authLevel = this.getAuthedLevel()
        this.tiers = PriceUtils.getTiers(airConfig._needMarkup, this.showLevel, this.authLevel)
      } else {
        this.tiers = PriceUtils.getTiers(false, false, 1)
      }
      this.filter.level = (this.tiers && this.tiers.length > 0) ? this.tiers[0].value : ''
      this.checkPriviledges(airConfig._needMarkup)
      const proxy = LocalStorageUtils.getConfiguration(this.localConfigId)
      if (proxy) {
        this.isShowingMoreSearchCondition = proxy.isAdvanced
        this.isAdvancedQuery = proxy.isAdvanced
        commonUtil.objCopy(proxy, this.filter)
        if (!StrUtils.isEmpty(this.filter.pol)) {
          this.polPort = this.allAirPort.filter(item => item.code === this.filter.pol)[0]
        }
        if (!StrUtils.isEmpty(this.filter.pod)) {
          this.podPort = this.allAirPort.filter(item => item.code === this.filter.pod)[0]
        }
      }
      this.$nextTick(async() => {
        this.pgsLMap = await this.privilegeUtil.getPOLPrivileges()
        this.pgsDMap = await this.privilegeUtil.getPODPrivileges()
        if (!this.isAdminOrHQ) {
          this.pols = this.privilegeUtil.getAirports(this.pgsLMap, this.allAirPort)
          this.pods = this.privilegeUtil.getAirports(this.pgsDMap, this.allAirPort)
        }
        this.setPosition()
      })
    },
    setPosition() {
    },
    saveConfig() {
      const data = deepClone(this.filter)
      delete data['createDateFrom']
      delete data['createDateTo']
      delete data['beginDate']
      delete data['endDate']
      data['isAdvanced'] = this.isAdvancedQuery
      LocalStorageUtils.setConfiguration(this.localConfigId, data)
    },
    checkPriviledges(needMarkup) {
      this.showLevel = this.isShowLevel(needMarkup)
    },
    isShowLevel(needMarkup) {
      let flag = needMarkup
      if (flag) {
        if (this.isQuery) {
          flag = this.isAdminOrHQ || this.privilegeUtil.isShowTier
        } else {
          flag = this.isAdminOrHQ || this.privilegeUtil.isApprove
        }
      }
      return flag
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery() {
      this.proxy = {}
      this.proxy['isLimited'] = true
      this.proxy['level'] = this.filter.level
      this.proxy['isAdvanced'] = false
      this.proxy['tenantId'] = 0
      if (this.showPriceNo) {
        const priceNo = this.filter.priceNo ? this.filter.priceNo.trim() : ''
        if (!priceNo || priceNo.length === 0) {
          this.simQueryPlaceholder = ''
          this.$refs.keyword.focus()
          this.$message.warning(this.$t('Pricing.priceNoPrompt'))
          return
        }
        this.proxy['priceNo'] = priceNo
      } else {
        if (!this.filter.simPol) {
          this.$message.warning(this.$t('Pricing.POLIsNull'))
          this.$refs.simPol.$refs['advanceSelectRef'].$refs.reference.focus()
          return
        }
        if (!this.filter.simPod) {
          this.$message.warning(this.$t('Pricing.PODIsNull'))
          this.$refs.simPod.$refs['advanceSelectRef'].$refs.reference.focus()
          return
        }
        if (this.filter.flightNumber) {
          this.proxy['flightNumber'] = this.filter.flightNumber
        }
        if (this.filter.aircraft) {
          this.proxy['aircraft'] = this.filter.aircraft
        }
        this.proxy['pol'] = this.filter.simPol
        this.proxy['pod'] = this.filter.simPod
      }
      this.saveConfig()
      this.$emit('simSearchItemCallBack', this.proxy)
    },
    toAdvancedQuery() {
      this.proxy = {}
      const proxy = this.proxy
      proxy['isLimited'] = true
      proxy['isAdvanced'] = true
      proxy['showLevel'] = this.showLevel
      proxy['level'] = this.filter.level
      proxy[this.rdoGroupOrg] = PriceUtils.getSearchPorts(this.filter, this.rdoGroupOrg, 'pols')
      proxy[this.rdoGroupDes] = PriceUtils.getSearchPorts(this.filter, this.rdoGroupDes, 'pods')
      if (!this.isAdminOrHQ) {
        if (!this.handleOrigin(proxy)) return
        if (!this.handleDestination(proxy)) return
        if (proxy.isAllPOD)proxy.podPgs = null// 避免传输无意义的数据
        if (proxy.pol === null && !proxy.isAllPOL && (!proxy.polPgs || proxy.polPgs.length === 0))	return null
        if (proxy.pod === null && !proxy.isAllPOD && (!proxy.podPgs || proxy.podPgs.length === 0))	return null
      } else {
        if (this.rdoGroupOrg === 'pols') {
          if (!StrUtils.isEmpty(this.filter.pols)) {
            proxy['polPgs'] = this.filter.pols.split(',')
          }
        }
        if (this.rdoGroupDes === 'pods') {
          if (!StrUtils.isEmpty(this.filter.pods)) {
            if (!this.handlePODSInput(proxy)) return
          }
        }
      }
      this.setDateValue('beginDate', false)
      this.setDateValue('endDate', true)
      this.setDateValue('createDateFrom', false)
      this.setDateValue('createDateTo', true)
      if (this.isManageModule || this.isShowCreatedBy) {
        if (this.filter.cmbCreatedBy === 'createdBy') {
          proxy['createdBy'] = this.filter.createdBy
        }
        if (this.filter.cmbCreatedBy === 'branch') {
          proxy['branchId'] = this.filter.branch
        }
      }
      proxy['carrier'] = this.filter.carrier
      this.saveConfig()
      this.$emit('advSearchItemResetCallBack', proxy)
    },
    setDateValue(field, isEnd) {
      if (!StrUtils.isEmpty(this.filter[field])) {
        this.proxy[field] = this.filter[field] + (isEnd ? ' 23:59:59' : '')
      }
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PADA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PADA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PADA_*_2'])) {
        return 2
      }
      return 99
    },
    upOrDownSearchCondition() {
      this.isShowingMoreSearchCondition = !this.isShowingMoreSearchCondition
      this.isAdvancedQuery = this.isShowingMoreSearchCondition
      this.$emit('click-more', this.isShowingMoreSearchCondition)
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
    },
    keyWordBlur() {
      this.simQueryPlaceholder = this.$t('Pricing.priceNoPrompt')
    },
    resetSearch() {
      const level = this.filter.level
      const currency = this.filter.currency
      this.filter = PriceUtils.resetFilter(this.filter)
      this.filter.cmbCreatedBy = 'createdBy'
      this.filter.currency = currency
      this.filter.level = level
      this.$emit('reset')
    },
    onLevelChanged() {
      this.$emit('onLevelChanged', { level: this.filter.level })
      this.toQuery()
    },
    changeCurrency(p) {
      this.filter.currency = p.value
      this.$emit('onGridRefresh')
    },
    handleOrigin(proxy) {
      if (this.rdoGroupOrg === 'pol' && !StrUtils.isEmpty(this.filter.pol)) {
        return this.handlePOLInput(proxy)
      }
      if (this.rdoGroupOrg === 'pols' && !StrUtils.isEmpty(this.filter.pols)) {
        return this.handlePOLSInput(proxy)
      }
      return this.handleCOLInput(proxy)
    },
    handleCOLInput(proxy) {
      if (StrUtils.isEmpty(proxy.col)) {
        if (!this.handleOriginIsNULL(proxy)) return false
      } else {
        const colsMap = this.colsMap
        if (!colsMap) {
          this.buildCOLMap()
        }
        if (!colsMap.hasOwnProperty(this.filter.col)) {
          this.$message.warning(this.$t('Pricing.NotAllowedFromCountry'))
          return false
        }
        proxy['polPgs'] = colsMap[proxy.col]
      }
      return true
    },
    buildCOLMap() {
      const { pols } = this
      const colsMap = {}
      if (!pols || pols.length === 0) {
        this.colsMap = colsMap
        return
      }
      let cy = ''
      for (const pt of pols) {
        if (!pt) {
          continue
        }
        cy = pt.countryCode
        if (!colsMap.hasOwnProperty(cy)) {
          colsMap[cy] = []
        }
        colsMap[cy].push(pt.code)
      }
      this.colsMap = colsMap
    },
    buildCODMap() {
      const { pods } = this
      const codsMap = {}
      if (!pods || pods.length === 0) {
        this.codsMap = codsMap
        return
      }
      let cy = ''
      for (const pt of pods) {
        if (!pt) {
          continue
        }
        cy = pt.countryCode
        if (!codsMap.hasOwnProperty(cy)) {
          codsMap[cy] = []
        }
        codsMap[cy].push(pt)
      }
      this.codsMap = codsMap
    },
    handleDestination(proxy) {
      if (this.rdoGroupDes === 'pod' && !StrUtils.isEmpty(this.filter.pod)) {
        return this.handlePODInput(proxy)
      }
      if (this.rdoGroupDes === 'pods' && !StrUtils.isEmpty(this.filter.pods)) {
        return this.handlePODSInput(proxy)
      }
      return this.handleCODInput(proxy)
    },
    handlePOLInput(proxy) {
      const pol = this.polPort
      if (pol === null) {
        if (!this.handleOriginIsNULL(proxy)) return false
      } else {
        if (!this.pgsLMap || !this.pgsLMap.hasOwnProperty(pol.countryCode + pol.code)) {
          this.$message.warning(this.$t('Pricing.NotAllowedPOL'))
          return false
        }
        proxy['polPgs'] = []
        proxy['polPgs'].push(this.filter.pol)
      }
      return true
    },
    handlePOLSInput(proxy) {
      const polsCode = this.filter.pols.split(',')
      const pols = this.allAirPort.filter(item => polsCode.indexOf(item.code) !== -1)
      proxy['polPgs'] = []
      for (const pol of pols) {
        if (!this.pgsLMap || !this.pgsLMap.hasOwnProperty(pol.countryCode + pol.code)) {
          this.$message.warning(StrUtils.substitute(this.$t('Pricing.NotAllowedPOL2'), pol.code))
          return false
        }
        proxy['polPgs'].push(pol.code)
      }
      return true
    },
    handleCODInput(proxy) {
      const cod = proxy.cod
      if (StrUtils.isEmpty(cod)) {
        if (!this.handleDestinationIsNULL(proxy)) return false
      } else {
        const codsMap = this.codsMap
        if (!codsMap) {
          this.buildCODMap()
        }
        if (codsMap.hasOwnProperty(cod)) {
          const pods = codsMap[proxy.cod]
          if (proxy.showLevel) {
            this.handlePodPgs_Tier(pods, proxy)
          } else {
            this.handlePodPgs_NoTier(pods, proxy)
          }
        } else {
          this.$message.warning(this.$t('Pricing.NotAllowedToCountry'))
          return false
        }
      }
      return true
    },
    // POL,COL,ROL三者没有填时，找出用户有权限的港口
    handleOriginIsNULL(proxy) {
      if (this.isAllPOL()) {
        proxy['pol'] = null
        proxy['isAllPOL'] = true
      } else {
        const pols = this.pols
        if (!pols || pols.length === 0) return false
        proxy['pol'] = null
        proxy['polPgs'] = []
        for (const pt of pols) {
          proxy['polPgs'].push(pt.code)
        }
      }
      return true
    },
    isAllPOL() {
      return this.$checkPermission(['PALA_*'])
    },
    polChange(p) {
      this.filter.pol = p.code
      this.polPort = p
    },
    podChange(p) {
      this.filter.pod = p.code
      this.podPort = p
    },
    handlePODInput(proxy) {
      const pod = this.podPort
      if (pod === null) {
        if (!this.handleDestinationIsNULL(proxy)) return false
      } else {
        proxy.pod = pod.code
        let pg = null
        if (this.isAdminOrHQ) {
          pg = this.privilegeUtil.pod2pg(pod.code, proxy.level.toString())
        } else {
          if (this.pgsDMap.hasOwnProperty(pod.countryCode + pod.code)) {
            pg = this.pgsDMap[pod.countryCode + pod.code]
            if (proxy.showLevel) {
              if (!this.checkPriviledge(pg, true, proxy)) return false
            } else {
              proxy.level = this.getTier(pg)
            }
          } else {
            this.$message.warning(this.$t('Pricing.NotAllowedPOD'))
            return false
          }
        }
        proxy.podPgs = [pg]
      }
      return true
    },
    handlePODSInput(proxy) {
      const podsCode = this.filter.pods.split(',')
      const pods = this.allAirPort.filter(item => podsCode.indexOf(item.code) !== -1)
      proxy['podPgs'] = []
      for (const pod of pods) {
        if (this.pgsDMap.hasOwnProperty(pod.countryCode + pod.code)) {
          const pg = this.pgsDMap[pod.countryCode + pod.code]
          proxy['podPgs'].push(pg)
          if (proxy.showLevel) {
            if (!this.checkPriviledge2(pod.code, pg, true, proxy)) return false
          } else {
            proxy.level = this.getTier(pg)
          }
        } else {
          this.$message.warning(StrUtils.substitute(this.$t('Pricing.NotAllowedPOD2'), pod.code))
          return false
        }
      }
      return true
    },
    getTier(pg) {
      if (this.isQuery && pg.point === '0') return 1
      return Number(pg.point)
    },
    checkPriviledge(pg, isShowAlert, proxy) {
      if (pg === null || Number(pg.point) > proxy.level) {
        if (isShowAlert) {
          this.$message.warning(this.$t('Pricing.NotAllowed'))
          this.isAlertShowed = true
        }
        return false
      }
      return true
    },
    checkPriviledge2(podCode, pg, isShowAlert, proxy) {
      if (pg === null || Number(pg.point) > proxy.level) {
        if (isShowAlert) {
          this.$message.warning(StrUtils.substitute(this.$t('Pricing.NotAllowedPOD2'), podCode))
          this.isAlertShowed = true
        }
        return false
      }
      return true
    },
    checkPgsPriviledges(pgs) {
      if (!pgs || pgs.length === 0) {
        this.$message.warning(this.$t('Pricing.NotAllowed'))
        return false
      }
      return true
    },
    handleDestinationIsNULL(proxy) {
      proxy.pod = null
      const pods = this.pods
      if (pods === null) return false
      if (this.showLevel) {
        proxy['isAllPOD'] = this.isAdminOrHQ || this.privilegeUtil.isAllPOD2(proxy.level)
        if (!proxy.isAllPOD) return this.handlePodPgs_Tier(pods, proxy)
      } else {
        if (!this.handlePodPgs_NoTier(pods, proxy)) return false
        if (proxy['isSameLevel']) proxy.isAllPOD = this.privilegeUtil.isAllPOD2(proxy.level)
      }
      return true
    },
    /**
     *	显示运价等级
     */
    handlePodPgs_Tier(pods, proxy) {
      if (!pods || pods.length === 0) return false
      const pgs = []
      let pg = null
      const len = pods.length
      for (let i = 0; i < len; i++) {
        pg = this.pgsDMap[pods[i].countryCode + pods[i].code]
        if (Number(pg.point) > proxy.level) continue
        pgs.push(pg)
      }
      proxy['podPgs'] = pgs
      if (!this.checkPgsPriviledges(proxy.podPgs)) return false
      return true
    },
    handlePodPgs_NoTier(pods, proxy) {
      if (!pods || pods.length === 0) return false
      const pgs = []
      let pg = null
      let tier = ''
      proxy.isSameLevel = true // 默认相同等级
      for (const pod of pods) {
        const key = pod.countryCode + pod.code
        if (key) {
          pg = this.pgsDMap[key]
          if (pg) {
            pgs.push(pg)
            if (tier === pg.point) continue
            if (!tier) {
              tier = pg.point
            } else {
              proxy.isSameLevel = false
            }
          }
        }
      }
      if (proxy.isSameLevel) proxy.level = Number(tier)
      if (this.isQuery) this.privilegeUtil.handlePODPriviledges(proxy, pgs)
      proxy['podPgs'] = pgs
      return true
    }
  }
}
</script>
<style lang="scss">
</style>
